module.exports = __webpack_public_path__ + "img/img_parking.597a1d2e.png";